'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TasksController = function () {
    /* @ngInject */
    function TasksController($scope, $rootScope, $state, $ionicLoading, ApiUser, $ionicPopup, $filter, $stateParams, $ionicScrollDelegate) {
        _classCallCheck(this, TasksController);

        this.ApiUser = ApiUser;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$filter = $filter;
        this.defaultTab = $stateParams.defaultTab;
        this.filterIsActive = true;
        this.filterButtonClass = '';
        this.$ionicScrollDelegate = $ionicScrollDelegate;
    }

    _createClass(TasksController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
            var currentUser = this.$rootScope.user;

            if (!currentUser) {
                this.ApiUser.getUser().then(function (res) {
                    if (angular.isDefined(res)) {
                        _this.taskParameters = { currentUserId: res.id };
                        _this.$ionicLoading.hide();
                    }
                });
            } else {
                this.taskParameters = { currentUserId: currentUser.id };
                this.$ionicLoading.hide();
            }
        }
    }, {
        key: 'popUp',
        value: function popUp($event, itemType) {
            var _this2 = this;

            var title = itemType === 'TASK' ? 'DELETE_TASKS' : 'DELETE_ACTIVITIES';
            var content = itemType === 'TASK' ? 'DELETE_TASKS_PROMPT' : 'DELETE_ACTIVITIES_PROMPT';

            $event.preventDefault();
            var dialogResult = this.$ionicPopup.confirm({
                title: this.$filter('translate')(title),
                template: this.$filter('translate')(content)
            });

            dialogResult.then(function (res) {
                if (res) {
                    _this2.showCheckboxes = !_this2.showCheckboxes;
                    if (itemType === 'TASK') {
                        _this2.deleteTasks();
                    } else {
                        _this2.deleteActivities();
                    }
                }
            });
        }
    }, {
        key: 'setCurrentTab',
        value: function setCurrentTab(tabName) {
            this.taskType = tabName || 'TASK';
            sessionStorage.setItem('task-tab', tabName);
            this.$ionicScrollDelegate.scrollTop();
        }
    }, {
        key: 'displayTab',
        value: function displayTab() {
            var currentTab = sessionStorage.getItem('task-tab') || 'TASK';
            this.taskType = currentTab;
        }
    }]);

    return TasksController;
}();

exports.default = TasksController;


/** WEBPACK FOOTER **
 ** ./src/app/components/tasks/tasks.controller.js
 **/